import { apiDelete, apiGet, apiPost, apiPut } from "./http";

export interface SubAdminDto {
  id: string;
  name: string;
  account: string;
  role: "admin" | "editor" | "viewer";
  disabled: boolean;
  permissions: string[];
}

export interface SubAdminLoginResultDto {
  legacyId: string;
  name: string;
  account: string;
  role: string;
  permissions: string[];
  accessToken?: string;
  tokenType?: string;
  expiresIn?: number;
  tenantLegacyId?: string;
  tenantName?: string;
}

export function fetchSubAdmins(tenantLegacyId: string) {
  return apiGet<SubAdminDto[]>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/sub-admins`);
}

export function createSubAdmin(
  tenantLegacyId: string,
  body: { name: string; account: string; password: string; role: string; permissions?: string[] },
) {
  return apiPost<SubAdminDto>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/sub-admins`, body);
}

export function patchSubAdmin(
  tenantLegacyId: string,
  subLegacyId: string,
  body: {
    name?: string;
    account?: string;
    password?: string;
    role?: string;
    disabled?: boolean;
    permissions?: string[];
  },
) {
  return apiPut<SubAdminDto>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/sub-admins/${encodeURIComponent(subLegacyId)}`,
    body,
  );
}

export function deleteSubAdmin(tenantLegacyId: string, subLegacyId: string) {
  return apiDelete(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/sub-admins/${encodeURIComponent(subLegacyId)}`);
}

export function loginSubAdmin(tenantLegacyId: string, account: string, password: string) {
  return apiPost<SubAdminLoginResultDto>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/sub-admins/login`,
    { account, password },
  );
}
